import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/8f0e4cfc-35a0-4a7c-aefb-ee9f6194a911.png"
              alt="Trio HVACR Services"
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Reviews
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('hours')}
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Hours
            </button>
          </div>

          <a
            href="tel:4433248816"
            className="hidden md:block bg-orange-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            (443) 324-8816
          </a>
        </div>
      </div>
    </nav>
  );
}
